import { useSelector } from 'react-redux';

import { getCurrency } from 'common/helpers/miscHelper';
import { currencyFormat } from 'common/helpers/numberHelper';

import BottleDeposit from './BottleDeposit';
import Duties from './Duties';
import DutyUnpaidEstimate from './DutyUnpaidEstimate';
import GiftCards from './GiftCards';
import PrimeSavings from './PrimeSavings';
import Shipping from './Shipping';
import Taxes from './Taxes';
import TaxesIncludedInPrice from './TaxesIncludedInPrice';

const CartSummary = (props) => {
  const { cart } = props;
  const settings = useSelector((state) => state.setting);
  return (
    <div className="c7-cart-summary">
      <div className="c7-cart-summary__subtotal">
        <div>Subtotal:</div>
        <div>{currencyFormat(cart.subTotal, settings)}</div>
      </div>
      <Shipping cart={cart} settings={settings} />
      <Taxes taxes={cart.taxes} settings={settings} />
      <Duties duties={cart.duties} settings={settings} />
      <BottleDeposit cart={cart} settings={settings} />

      <div className="c7-cart-summary__total">
        <div>Total:</div>
        <div>
          <span>{getCurrency(settings)}</span>{' '}
          {currencyFormat(cart.total, settings)}
        </div>
      </div>
      <TaxesIncludedInPrice taxes={cart.taxes} settings={settings} />
      <GiftCards cart={cart} settings={settings} />
      <DutyUnpaidEstimate duties={cart.duties} settings={settings} />
      <PrimeSavings cart={cart} settings={settings} />
    </div>
  );
};

export default CartSummary;
